window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.superPredahRepo = function () {
    var url = 'api/superPredah';

    var get = function () {
        return fetch(url, {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    var create = function (tipOgranicenja, ogranicenjeId, iznos, resetOgranicenja) {
        return fetch(url , {
            method: 'POST',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify({
                tipOgranicenjaId: tipOgranicenja,
                ogranicenjeId: ogranicenjeId,
                iznos: iznos,
                resetOgranicenja: resetOgranicenja
            })
        })
            .then(casino.repos.base.checkResponse)
            .catch(casino.repos.base.handleNetworkException);
    };


    return {
        get: get,
        create: create
    }

}();